import axios from '../service/axios/axios';

export default {
    //获取诊所列表
    getClinicList(data) {
        return axios({
            method: 'post',
            url: 'platform/clinic/getClinicList',
            data: data
        });
    },
    //获取诊所详情
    getClinicInfo({ hospital_id }) {
        return axios({
            method: 'post',
            url: 'platform/clinic/getClinicInfo',
            data: { hospital_id }
        });
    },
    // 保存诊所信息
    saveClinicInfo(data) {
        return axios({
            method: 'post',
            url: 'platform/clinic/saveClinicInfo',
            data: data
        });
    },
    // 修改诊所状态 （1锁定，2解锁）
    changeClinicStatus({ hospital_id, hospital_status }) {
        return axios({
            method: 'post',
            url: 'platform/clinic/changeClinicStatus',
            data: { hospital_id, hospital_status }
        });
    },
    //设置测试诊所（1开启，2关闭）
    setTestClinic({ hospital_id, status }) {
        return axios({
            method: 'post',
            url: 'platform/clinic/setTestClinic',
            data: { hospital_id, status }
        });
    },
    //获取特色科室列表
    getSpecialDepartmentList(data) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/getSpecialDepartmentList',
            data: data
        });
    },
    //获取特色科室详情
    getSpecialDepartmentInfo({ department_id }) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/getSpecialDepartmentInfo',
            data: { department_id }
        });
    },
    //保存特色科室信息
    saveSpecialDepartmentInfo(data) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/saveSpecialDepartmentInfo',
            data: data
        });
    },
    //获取医生维护列表
    getDoctorMaintenanceList(data) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/getDoctorMaintenanceList',
            data: data
        });
    },
    //搜索医生信息
    searchDoctorInfo({ phone }) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/searchDoctorInfo',
            data: { phone }
        });
    },
    //添加医生维护
    addDoctorMaintenance({ department_id, doctor_id }) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/addDoctorMaintenance',
            data: { department_id, doctor_id }
        });
    },
    // 设置请求协诊权限
    setRequestAssist(data) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/setRequestAssist',
            data: data
        });
    },
    // 设置协诊权限
    setAssist(data) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/setAssist',
            data: data
        });
    },
    // 医生排序
    editDoctorSort(data) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/editDoctorSort',
            data: data
        });
    },
    //医生删除
    delDoctor({ department_id, doctor_id }) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/delDoctor',
            data: { department_id, doctor_id }
        });
    },
    // 获取患教文章列表
    getLibraryList({ department_id,pageNumber,page }) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/getArticlesOnPatientEducationList',
            data: { department_id,page,pageNumber }
        });
    },
    //获取患教文章详情
    getLibraryInfo({ art_id }) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/getArticlesOnPatientEducationInfo',
            data: { art_id }
        });
    },
    // 保存患教文章信息
    saveLibraryInfo(data) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/saveArticlesOnPatientEducationInfo',
            data: data
        });
    },
    // 患教文章排序
    editLibrarySort(data) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/editArticlesOnPatientEducationSort',
            data: data
        });
    },
    //患教文章删除
    delLibrary({ department_id, art_id }) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/deleteArticlesOnPatientEducationInfo',
            data: { department_id, art_id }
        });
    },
    //修改患教文章状态
    changeLibraryStatus({ status, art_id }) {
        return axios({
            method: 'post',
            url: 'platform/sdepartment/changeArticlesOnPatientEducationStatus',
            data: { status, art_id }
        });
    },
}